let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aGMGI")).then(() => parcelRequire('4wp5m'));